/**
 * /eric/os - Operating System engagements (OS Foundation Batch 2, PRD-004
 * §4 / §7).
 *
 * Route config only. Component lives in eric.os.lazy.tsx (code-split). No
 * loader, beforeLoad, or validateSearch. The operator guard is on the parent
 * /eric route (eric.tsx requireOperatorEntry).
 */

import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/eric/os')({});
